import styled from 'styled-components'
import { Redirect } from 'react-router-dom'
import React, { useState } from 'react';
import logo from '../../assets/images/logo.png'
import useAuth from '../../hooks/useAuth'
import { Helmet } from "react-helmet"
import SignUp from '../SignUp/SignUp';

const Box = styled.div`
  margin: 0 auto;
  padding: 20px;
  width: 100%;
  max-width: 600px;
  color: var(--color-text-primary);

  display: flex;
  flex-direction: column;
  align-items: center;
`

const Divider = styled.hr`
  border-top: 1px solid var(--color-bg-sidebar);
  margin: 10px 0;
  margin-top: 20px;
`

const Header = styled.header`
  margin-top: 20px;
  margin-bottom: 44px;
  width: 75%;
`

const Main = styled.main`
  margin-top: 44px;
  width: 85%;
`

const Footer = styled.footer`
  margin-top: 18px;
  width: 83%;
  font-size: 12px;
  line-height: 18px;
  color: var(--color-text-secondary);
`

const Heading = styled.h1`
  margin-right: auto;
  color: var(--color-text-primary);
  display: inline-block;
  padding-bottom: 20px;
  font-size: 42px;
  font-weight: 400;
  line-height: 0.8;
  text-transform: capitalize;
  position: relative;

  &::after {
    content: '';
    width: 90px;
    height: 3px;
    background-color: var(--color-primary);
    position: absolute;
    top: 100%;
    left: 0;
    transform: translateY(-100%);
  }
`

const Logo = styled.figure`
  width: 100%;
`

// const Version = styled.p`
//   margin-top: -10px;
//   text-align: right;
//   font-size: 14px;
// `

const Button = styled.button`
  background-color: var(--color-primary);
  border: none;
  outline: none;
  border-radius: 20px;
  cursor: pointer;
  height: 32px;
  width: 100%;
  font-size: 14px;
  color: var(--color-bg-main);
  text-transform: uppercase;
  transition: background-color 0.2s ease;
  margin-top: 10px;

  &:hover {
    background-color: var(--color-secondary);
  }
`

const ThankYouBanner = styled.div`
  padding: 20px;
  background-color: var(--color-primary);
  color: var(--color-bg-main);
  text-align: left;
  align-items: center;
  border-radius: 4px;
`;

const getUrlParameter = (name) => {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


const SignIn = () => {
  const { isAuthenticated, login } = useAuth()
  const [ formSubmitted, setFormSubmitted ] = useState(false)
  
  if (isAuthenticated) {
    return <Redirect to='/' />
  }
  
  const handleFormSubmitted = (formData) => {
    setFormSubmitted(true)
  };

  return (
    <Box>
      <Header>
        <Logo>
          <img src={logo} alt="brand-logo" style={{ width: '100%' }} />
        </Logo>
        {/* <Version>Version 0.1.0</Version> */}
      </Header>
      <Heading>Welcome!</Heading>
      <Main>
      {formSubmitted ? (
        <ThankYouBanner>
          <strong>Success!</strong> 🚀<br />
          We've got your details. A response will be heading your way within 24-48 hours to the email you've shared. Thanks for choosing us!
        </ThankYouBanner>
      ) : (
        <>
        { getUrlParameter('x-amzn-marketplace-token')  ? (
          <>
            <SignUp onFormSubmit={handleFormSubmitted} />
            <Divider />
          </>
          ) : null}
          <Button onClick={login}>Login</Button>
        </>
      )}
        <Helmet>
            <script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=48eb206c-82f3-4e21-b050-b77808c28b91"> </script>
        </Helmet>
      </Main>
      <Footer>
        <p>
          For questions, please contact your dedicated Caylent Client Success Manager.
        </p>
      </Footer>
    </Box>
  )
}

export default SignIn
